"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticularMentions = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../hooks/useLangContext");
const Text_1 = __importDefault(require("../_core/Text"));
const LANG_MAP = {
    en: 'valueEn',
    fr: 'valueFr',
};
const ParticularMentions = ({ particularMentions, }) => {
    const { lang } = (0, useLangContext_1.useLangContext)();
    if (!particularMentions.length) {
        return null;
    }
    const currentLang = LANG_MAP[lang];
    return (react_2.default.createElement(react_1.Stack, { spacing: "0" }, particularMentions.map((particularMention, idx) => (react_2.default.createElement(Text_1.default, { fontWeight: "weight-500", key: idx, textAlign: "right" }, particularMention[currentLang])))));
};
exports.ParticularMentions = ParticularMentions;
